import { DbUpdateBrekageReport } from "../../../data/usecases/update-brekage-report";
import { UpdateBreakageReport } from "../../../domain/usecases/update-breakage-report";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbUpdateBreakageReport = (): UpdateBreakageReport =>
  new DbUpdateBrekageReport(
    makeApiUrl("/breakage"),
    makeAuthorizeHttpClientDecorator()
  );
